import InvictusHowRegister from 'components/Invictus/InvictusHowRegister'
import InvictusVerticalCarousal from './components/InvictusVerticalCarousal'
import InvictusTestCriteria from '../Invictus/InvictusTestCriteria'
import styles from './invictusLanding.module.css'
import InvictusEliteProgram from 'components/Invictus/InvictusEliteProgram'
import InvictusTeachercontri from 'components/Invictus/InvictusTeachercontri'
import WhyIat from './components/WhyIat'

const InvictusLandingTemplate = () => {
    return (
        <div className={styles.body_wrapper}>
            <div style={{ position: 'sticky', zIndex: 0, top: "0px" }}>
                <InvictusTestCriteria />
            </div>
            <div style={{ position: 'sticky', zIndex: 5, top: "0px" }}>
                <div style={{ position: 'relative' }}>
                    <div style={{
                        position: 'sticky',
                        top: "0px",
                        backgroundColor: 'white',
                        minHeight: 'max-content',
                    }}>
                        <WhyIat />
                    </div>
                </div>
                <div style={{ position: 'sticky', top: "0px", backgroundColor:'white' }}>
                    <InvictusTeachercontri />
                </div>
                <InvictusVerticalCarousal />
                <div style={{
                    position: 'relative',
                    zIndex: 10,
                    top: "0px",
                    backgroundColor: 'white',
                    height: 'max-content',
                    padding: '2rem 0'
                }}>
                    <InvictusEliteProgram />
                    <InvictusHowRegister />
                </div>
            </div>
        </div>
    )
}

export default InvictusLandingTemplate